import React, { FC, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { AnalyticsEventSchema } from "../../../models/types";
import { useLocalState } from "../../../graphql/hooks";
import Prism from "prismjs";
import "prismjs/components/prism-json.min";
import "prismjs/themes/prism.css";

interface Props {
    show: boolean;
    analyticsEvent?: AnalyticsEventSchema;
    updateSchemaEvent: () => void;
    onClose: () => void;
}

export const AnalyticsEventUploadModal: FC<Props> = ({
    show,
    analyticsEvent,
    updateSchemaEvent,
    onClose
}) => {
    const codeBlock = JSON.stringify(analyticsEvent, null, 2);
    const { useDarkMode } = useLocalState();

    useEffect(() => {
        if (codeBlock) {
            Prism.highlightAll();
        }
    }, [codeBlock]);

    if (!analyticsEvent) {
        return null;
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            keyboard={true}
            className={useDarkMode ? "modal-dark" : ""}
        >
            <Modal.Header closeButton>
                <Modal.Title>{`Save  "${analyticsEvent?.eventName}" to Event Library`}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-2">
                <div>
                    <pre>
                        <code className="language-json">{codeBlock}</code>
                    </pre>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center mt-2">
                <Button variant="analytics" onClick={updateSchemaEvent}>
                    Save to Library
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
